import { ListViewProduct } from 'models/ListViewProduct';
import styles from '../../styles.scss';
import { Container } from 'components/Shared/List';
import { isMobile } from 'components/Shared/responsive';
import { getProductId } from '../../selector';
import { SliderDots } from 'components/SliderDots';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import Carousel from 'components/Shared/Carousel';
import connect from 'components/Shared/connect';
import { ProductCard } from 'components/Shared/Product';
import { SrcSet } from 'components/Shared/Image/SrcSet';
import { useIntersectionObserver } from 'hooks';
import { SetElementProps, TrackedElement } from 'hooks/useIntersectionObserver';

interface OwnProps {
  products: ListViewProduct[];
  onProductClick?: (product: ListViewProduct, index?: number) => void;
  gtmOnViewItems?: (products: ListViewProduct[]) => void;
}

interface MergedProps extends OwnProps {
  isMobile: boolean;
  productId: string;
}

const MOBILE_WIDTH = 360;
const DESKTOP_WIDTH = 227;
const IMAGE_MARGIN = 2;

const sizes: { [key: string]: SrcSet } = {
  default: {
    viewWidth: MOBILE_WIDTH,
    width: MOBILE_WIDTH,
    height: MOBILE_WIDTH
  },
  medium: {
    viewWidth: DESKTOP_WIDTH,
    width: DESKTOP_WIDTH,
    height: DESKTOP_WIDTH
  }
};

const getPicture = (isMobile: boolean) => {
  return {
    height: isMobile ? MOBILE_WIDTH + IMAGE_MARGIN : DESKTOP_WIDTH + IMAGE_MARGIN,
    width: isMobile ? MOBILE_WIDTH + IMAGE_MARGIN : DESKTOP_WIDTH + IMAGE_MARGIN,
    className: styles.productImage
  };
};

const renderProduct =
  (
    isMobile: boolean,
    onClick: (product: ListViewProduct) => void,
    setElementRef: (props: SetElementProps<ListViewProduct>) => void
  ) =>
  (item: ListViewProduct) => (
    <ProductCard
      ref={node => setElementRef({ ref: node, payload: item })}
      onLinkClick={() => onClick(item)}
      page="switchProductlist"
      picture={getPicture(isMobile)}
      {...(item as ProductlistViewProduct)}
      customSizes={sizes}
    />
  );

const _ProductListView = ({
  products,
  isMobile,
  productId,
  onProductClick,
  gtmOnViewItems
}: MergedProps) => {
  const { setElementRef } = useIntersectionObserver({
    onBatchVisible: handleElementsVisible
  });

  function handleElementsVisible(elements: TrackedElement<ListViewProduct>[]) {
    const viewedItems = elements.map(element => {
      return element.payload;
    });

    if (gtmOnViewItems) {
      gtmOnViewItems(viewedItems);
    }
  }

  const handleOnClick = (product: ListViewProduct) => {
    if (onProductClick) {
      onProductClick(product, undefined);
    }
  };

  if (isMobile) {
    return (
      <div className={styles.removeSpace}>
        <Carousel
          classNames={{
            slides: styles.carouselSlides,
            tabs: styles.mobileCarouselTabs
          }}
          key={productId}
          spacing
          slidesData={products}
          RenderSlideTab={SliderDots}
        >
          {renderProduct(isMobile, handleOnClick, setElementRef)}
        </Carousel>
      </div>
    );
  }
  return (
    <Container items={products}>{renderProduct(isMobile, handleOnClick, setElementRef)}</Container>
  );
};

export const ProductListView = connect<MergedProps, OwnProps>(state => ({
  isMobile: isMobile(state),
  productId: getProductId(state.currentPage)
}))(_ProductListView);
